import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

import { SharedCardListSkeletonComponent } from './components/shared-card-list-skeleton/shared-card-list-skeleton.component';
import { SharedGridSkeletonComponent } from './components/shared-grid-skeleton/shared-grid-skeleton.component';
import { SharedSideNavSkeletonComponent } from './components/shared-side-nav-skeleton/shared-side-nav-skeleton.component';
import { SharedTableSkeletonComponent } from './components/shared-table-skeleton/shared-table-skeleton.component';
import { SharedTemplateSkeletonComponent } from './components/shared-template-skeleton/shared-template-skeleton.component';
import { SharedTwoColumnSideNavSkeletonComponent } from './components/shared-two-column-side-nav-skeleton/shared-two-column-side-nav-skeleton.component';

@NgModule({
  imports: [CommonModule, SkeletonModule],
  declarations: [
    SharedTableSkeletonComponent,
    SharedSideNavSkeletonComponent,
    SharedTwoColumnSideNavSkeletonComponent,
    SharedTemplateSkeletonComponent,
    SharedCardListSkeletonComponent,
    SharedGridSkeletonComponent,
  ],
  exports: [
    SharedSideNavSkeletonComponent,
    SharedTableSkeletonComponent,
    SharedTwoColumnSideNavSkeletonComponent,
    SharedTemplateSkeletonComponent,
    SharedCardListSkeletonComponent,
    SharedGridSkeletonComponent,
  ],
})
export class SharedSkeletonLibModule {}
